import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import {
  creaLiderSolicitud,
  obtenerDepartamento,
  obtenerMunicipio,
} from "../../../Services/Rest";

const api = axios.create({
  auth: {
    username: "BasicAuth@icontec.org",
    password: "yQLzqmR7eZSuAmQZUqhY",
  },
});

function CreaLider({ idSolicitud }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [municipios, setMunicipios] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);

  const [formData, setFormData] = useState({
    Nombre: "",
    Cargo: "",
    Telefono: "",
    Celular: "",
    Departamento: "",
    Ciudad: "",
    Direccion: "",
    Correo: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [munRes, depRes] = await Promise.all([
          api.get(obtenerMunicipio),
          api.get(obtenerDepartamento),
        ]);
        setMunicipios(munRes.data);
        setDepartamentos(depRes.data);
      } catch (err) {
        console.error("Error cargando datos:", err);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post(creaLiderSolicitud, {
        ...formData,
        SolicitudId: idSolicitud,
      });
      alert("¡Líder creado con éxito!");
      setModalIsOpen(false);
      // aquí puedes refrescar tabla de líderes desde el padre si lo necesitas
    } catch (err) {
      console.error(err);
      alert("Error al crear líder");
    }
  };

  return (
    <div>
      <button
        className="btn btn-primary btn-lg"
        onClick={() => setModalIsOpen(true)}
      >
        Nueva
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Crear Líder"
      >
        <div className="container">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Crear Líder</h6>
            </div>
            <div className="card-body">
              <form className="user" onSubmit={handleSubmit}>
                <div className="form-group row">
                  <div className="col-sm-6">
                    <input
                      type="text"
                      name="Nombre"
                      placeholder="Nombre"
                      className="form-control form-control-user"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-sm-6">
                    <input
                      type="text"
                      name="Cargo"
                      placeholder="Cargo"
                      className="form-control form-control-user"
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6">
                    <input
                      type="number"
                      name="Telefono"
                      placeholder="Teléfono"
                      className="form-control form-control-user"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-sm-6">
                    <input
                      type="number"
                      name="Celular"
                      placeholder="Celular"
                      className="form-control form-control-user"
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6">
                    <select
                      name="Ciudad"
                      className="btn btn-secondary btn-user btn-block"
                      onChange={handleChange}
                      required
                    >
                      <option value="">Seleccione municipio</option>
                      {municipios.map((item, i) => (
                        <option key={i} value={item.municipio}>
                          {item.municipio}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-sm-6">
                    <select
                      name="Departamento"
                      className="btn btn-secondary btn-user btn-block"
                      onChange={handleChange}
                      required
                    >
                      <option value="">Seleccione departamento</option>
                      {departamentos.map((item, i) => (
                        <option key={i} value={item.departamento}>
                          {item.departamento}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-sm-6">
                    <input
                      type="text"
                      name="Direccion"
                      placeholder="Dirección"
                      className="form-control form-control-user"
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-sm-6">
                    <input
                      type="email"
                      name="Correo"
                      placeholder="Correo"
                      className="form-control form-control-user"
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-user btn-block"
                >
                  Guardar
                </button>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaLider;
